import { Link } from "react-router-dom";
import { ArrowRight, Newspaper } from "lucide-react";
import { CATEGORY_IMAGES } from "../../lib/volunteerVisuals";

export const CategoryGrid = ({ info, onPick }) => (
  <div className="grid gap-5 sm:grid-cols-2 lg:grid-cols-3" data-testid="category-grid">
    {info.map((c) => (
      <div key={c.name} className="flex flex-col overflow-hidden rounded-3xl border border-slate-200 bg-white" data-testid={`category-card-${c.name.toLowerCase().replace(/[^a-z0-9]+/g, "-")}`}>
        <img src={CATEGORY_IMAGES[c.name]} alt="" loading="lazy" className="h-36 w-full object-cover" />
        <div className="flex flex-1 flex-col p-5">
          <h3 className="text-lg font-semibold text-slate-900">{c.name}</h3>
          <p className="mt-1 text-sm text-slate-600">{c.examples}</p>
          <p className="mt-3 text-sm font-semibold text-emerald-800">{c.count} open opportunities</p>
          <div className="mt-auto flex items-center justify-between pt-4">
            <button onClick={() => onPick(c.name)} data-testid={`category-browse-${c.name.toLowerCase().replace(/[^a-z0-9]+/g, "-")}`} className="btn-green inline-flex items-center gap-1 rounded-full px-4 py-2 text-sm font-semibold">Browse <ArrowRight size={14} /></button>
            <Link to={`/pulse?category=${encodeURIComponent(c.news_topic)}`} data-testid={`category-news-${c.name.toLowerCase().replace(/[^a-z0-9]+/g, "-")}`} className="inline-flex items-center gap-1 text-sm text-sky-800 hover:underline"><Newspaper size={14} />Community stories</Link>
          </div>
        </div>
      </div>
    ))}
  </div>
);
